module.exports = __webpack_public_path__ + "static/media/undraw_mobile_apps_4wgf.a0bc5587.svg";